import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * チャットルーム一覧
 *
 * 自分が所属しているチャットルームの一覧を返す
 * 発言が一つもないルームに関しては返却しない
 */
export class FetchRoom implements APIRequest<Monitaro.FetchRoomResponse> {
  response: Monitaro.FetchRoomResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/rooms`
  }
}

/**
 * チャットルームの作成
 *
 * MRから病院管理者に向けてチャットを申請する
 */
export class PostRoom implements APIRequest<Monitaro.PostRoomResponse> {
  response: Monitaro.PostRoomResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Monitaro.RoomRequest
  constructor(params: Monitaro.RoomRequest) {
    this.params = params
    this.path = `/rooms`
  }
}

/**
 * 公開されているグループ一覧
 *
 * 自分に公開されているグループ一覧を取得する
 */
export class FetchRoomGroups implements APIRequest<Monitaro.FetchRoomGroupsResponse> {
  response: Monitaro.FetchRoomGroupsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/rooms/groups`
  }
}

/**
 * 新規メッセージの宛先候補一覧
 *
 * チャット可能な病院管理者と自分に公開されているグループをまとめて取得する。
 * 病院管理者は最終利用日時、グループは作成日時を基準に、新しい順に混ぜて並べる
 */
export class FetchRoomRecipients implements APIRequest<Monitaro.FetchRoomRecipientsResponse> {
  response: Monitaro.FetchRoomRecipientsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/rooms/recipients`
  }
}

/**
 * チャット可能な病院管理者一覧
 *
 * チャットが可能な病院管理者一覧を取得する
 */
export class FetchRoomDoctors implements APIRequest<Monitaro.FetchRoomDoctorsResponse> {
  response: Monitaro.FetchRoomDoctorsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/rooms/doctors`
  }
}

/**
 * チャット可能な病院管理者のチェック
 *
 * チャットが可能な病院管理者かをチェックする
 */
export class GetRoomDoctors implements APIRequest<Monitaro.GetRoomDoctorsResponse> {
  response: Monitaro.GetRoomDoctorsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(doctor: string) {
    this.path = `/rooms/doctors/${doctor}`
  }
}

/**
 * チャットルームのユーザー一覧
 *
 * 自分が所属しているチャットルームで指定されたIDのユーザー一覧を返す。
 */
export class FetchRoomTalkers implements APIRequest<Monitaro.FetchRoomTalkersResponse> {
  response: Monitaro.FetchRoomTalkersResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(room: string, query?: Monitaro.Query) {
    this.params = query
    this.path = `/rooms/${room}/talkers`
  }
}

/**
 * チャットルームの取得
 *
 * 指定されたIDのルームデータを取得する
 */
export class GetRoom implements APIRequest<Monitaro.GetRoomResponse> {
  response: Monitaro.GetRoomResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(room: string) {
    this.path = `/rooms/${room}`
  }
}

/**
 * チャットルームからの退出
 *
 * 指定されたルームからの退出
 */
export class DeleteRoom implements APIRequest<Monitaro.DeleteRoomResponse> {
  response: Monitaro.DeleteRoomResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(room: string) {
    this.path = `/rooms/${room}`
  }
}
